import React from 'react';
import { useSelector } from 'react-redux';
import { useSitemap, useLabels, usePrefs } from 'wsm-common-data';
import { setUrl } from '../utils/setUrl';

const PromotionLink = () => {
	const sitemap = useSitemap();
	const labels = useLabels();
	const { promotionLinkStyle, promotionLinkLabel, promotionLinkUrlOverride } =
		usePrefs();
	const { vehicleData } = useSelector((state) => state);

	const modelParam = vehicleData.model
		? `model=${encodeURIComponent(vehicleData.model)}`
		: '';

	const trimmedPromotionLinkUrlOverride = (
		promotionLinkUrlOverride || ''
	).trim();

	const href = trimmedPromotionLinkUrlOverride
		? setUrl(sitemap, trimmedPromotionLinkUrlOverride)
		: `${sitemap.get('PROMOTIONS_LISTING_NEW')}?${modelParam}`;

	return (
		<a className={`btn ${promotionLinkStyle} mt-3`} href={href}>
			{labels.get(promotionLinkLabel)}
		</a>
	);
};

export default PromotionLink;
